(() => {
  const fitLabels = {
    '1/5': 'Runs small',
    '2/5': 'Slightly small',
    '3/5': 'True to size',
    '4/5': 'Slightly large',
    '5/5': 'Runs large'
  };

  const fitPositions = {
    '1/5': '0%',
    '2/5': '25%',
    '3/5': '50%',
    '4/5': '75%',
    '5/5': '100%'
  };

  let reviewsOpen = false;
  let scheduled = false;

  function getWidget() {
    return document.querySelector('#judgeme_product_reviews');
  }

  function getReviewCount(widget) {
    const text = Array.from(
      widget.querySelectorAll('.jm-average-rating-display .jm-text')
    )
      .map(el => el.textContent.trim())
      .find(value => /reviews?/i.test(value));

    return Number(text?.match(/\d+/)?.[0] || 0);
  }

  function hasReviews(widget) {
    return (
      getReviewCount(widget) > 0 &&
      !widget.querySelector('.jm-no-reviews-state')
    );
  }

  function formatJudgeMeFit(widget) {
    widget
      .querySelectorAll('.jm-custom-answer-list__item')
      .forEach(item => {
        const heading = item.querySelector('.jm-cluster:first-child');
        if (!heading) return;

        const parts = heading.querySelectorAll(':scope > .jm-text');
        if (parts.length < 2) return;

        const label = parts[0];
        const value = parts[1];

        if (
          label.textContent.trim().toLowerCase() !== 'fit' &&
          !item.dataset.faFitValue
        ) {
          return;
        }

        if (!item.dataset.faFitValue) {
          const raw = value.textContent.trim();

          if (fitLabels[raw]) {
            item.dataset.faFitValue = raw;
          }
        }

        const rawValue = item.dataset.faFitValue;
        if (!fitLabels[rawValue]) return;

        label.textContent = 'Fit:';
        value.textContent = fitLabels[rawValue];

        const progress = item.querySelector('.jm-progress-bar');
        const fill = item.querySelector('.jm-progress-bar__fill');

        if (!progress || !fitPositions[rawValue]) return;

        const position = fitPositions[rawValue];

        if (fill) {
          fill.style.width = position;
        }

        progress.style.backgroundImage = `
          linear-gradient(
            to right,
            transparent calc(${position} - .5px),
            #000 calc(${position} - .5px),
            #000 calc(${position} + .5px),
            transparent calc(${position} + .5px)
          )
        `;
      });
  }

  function formatReplies(widget) {
    widget.querySelectorAll('.jm-shop-reply').forEach(reply => {
      const text = reply.querySelector('.jm-shop-reply__text');
      const nativeButton = reply.querySelector(
        '.jm-shop-reply__expand-button'
      );

      if (!text) return;

      if (nativeButton) {
        nativeButton.style.display = 'none';
      }

      let button = reply.querySelector('.fa-reply-toggle');

      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'fa-reply-toggle';
        button.textContent = 'More';
        button.setAttribute('aria-expanded', 'false');

        button.addEventListener('click', () => {
          const expanded = reply.classList.toggle(
            'fa-reply-expanded'
          );

          button.textContent = expanded ? 'Less' : 'More';
          button.setAttribute(
            'aria-expanded',
            expanded ? 'true' : 'false'
          );
        });

        reply.appendChild(button);
      }
    });
  }

  function ensureReviewToggle(widget) {
    let button = widget.querySelector('.fa-review-toggle');

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'fa-review-toggle';

      button.addEventListener('click', () => {
        reviewsOpen = !reviewsOpen;
        updateReviewState(widget);
      });
    }

    return button;
  }

  function removeReviewToggle(widget) {
    widget.querySelector('.fa-review-toggle')?.remove();
  }

    function placeReviewToggle(widget, button) {
  if (reviewsOpen) {
    const pagination = widget.querySelector(
      '.jm-pagination-controls'
    );

    if (pagination) {
      if (button.parentElement !== pagination) {
        pagination.appendChild(button);
      }

      button.classList.add('fa-review-toggle--pagination');
      return;
    }
  }

  const rightSide = widget.querySelector(
    '.jm-review-widget-minimal-header__filter-container'
  );

  const headerRow =
    rightSide?.parentElement ||
    widget.querySelector(
      '.jm-review-widget__header .jm-cluster'
    );

  if (headerRow && rightSide) {
    if (
      button.parentElement !== headerRow ||
      button.nextElementSibling !== rightSide
    ) {
      headerRow.insertBefore(button, rightSide);
    }
  }

  button.classList.remove('fa-review-toggle--pagination');
}

  function updateReviewState(widget) {
    if (!hasReviews(widget)) {
      reviewsOpen = false;

      widget.classList.remove('fa-reviews-open');
      widget.classList.add('fa-reviews-closed');

      removeReviewToggle(widget);
      return;
    }

    const button = ensureReviewToggle(widget);
    const count = getReviewCount(widget);

    widget.classList.toggle('fa-reviews-open', reviewsOpen);
    widget.classList.toggle('fa-reviews-closed', !reviewsOpen);

    button.setAttribute(
      'aria-expanded',
      reviewsOpen ? 'true' : 'false'
    );

    if (reviewsOpen) {
      button.textContent = 'HIDE REVIEWS';
    } else {
      const noun = count === 1 ? 'REVIEW' : 'REVIEWS';
      button.textContent = `READ ${count} ${noun}`;
    }

    requestAnimationFrame(() => {
      placeReviewToggle(widget, button);
    });
  }

  function scrollToReviews(widget) {
    /*
     * Leave room for sticky header / sticky add-to-bag.
     * Slightly larger offset on mobile.
     */
    const offset = window.innerWidth < 750 ? 115 : 95;

    const top =
      widget.getBoundingClientRect().top +
      window.scrollY -
      offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  }

  function openReviewsAndScroll() {
    const widget = getWidget();
    if (!widget || !hasReviews(widget)) return;

    reviewsOpen = true;
    updateReviewState(widget);

    /*
     * Allow the collapsed content to enter the DOM/layout
     * before calculating our scroll position.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToReviews(widget);
      });
    });
  }

  document.addEventListener(
    'click',
    event => {
      const widget = getWidget();
      if (!widget || widget.contains(event.target)) return;

      const knownTrigger = event.target.closest(`
        .jdgm-prev-badge,
        .jdgm-preview-badge,
        .jm-preview-badge,
        [data-widget="rating"],
        [data-widget-name="preview_badge"],
        [data-widget-name="star_rating"],
        a[href*="#judgeme_product_reviews"],
        a[href*="#judgeme"]
      `);

      /*
       * Fallback for Judge.me's Shopify app block.
       * If an app block outside the review widget contains
       * "review/reviews", treat it as the PDP rating badge.
       */
      const appBlock = event.target.closest('.shopify-app-block');

      const judgeMeRatingBlock =
        appBlock &&
        !widget.contains(appBlock) &&
        /\breviews?\b/i.test(appBlock.textContent);

      if (!knownTrigger && !judgeMeRatingBlock) return;

      if (!hasReviews(widget)) return;

      event.preventDefault();
      event.stopPropagation();

      openReviewsAndScroll();
    },
    true
  );

  window.addEventListener('hashchange', () => {
    if (/judge|review/i.test(window.location.hash)) {
      openReviewsAndScroll();
    }
  });

  function prepareWidget() {
    const widget = getWidget();
    if (!widget) return;

    formatJudgeMeFit(widget);
    formatReplies(widget);
    updateReviewState(widget);
  }

  function schedulePrepare() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      prepareWidget();
    });
  }

  prepareWidget();

  const observer = new MutationObserver(schedulePrepare);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();